import { slug } from 'github-slugger'

export interface Heading {
  id: string
  text: string
  children: Heading[]
}

export function parseToc(
  headingElements: {
    id: string
    textContent: string | null
    tagName: string
  }[],
) {
  const headings: Heading[] = []
  let parentStack: Heading[] = []
  headingElements.forEach(element => {
    const id = element.id
    const text = element.textContent || ''

    const headingLevel = Number(element.tagName[1]) - 2
    parentStack = parentStack.slice(0, headingLevel)

    const heading = { id, text, children: [] }

    if (parentStack.length === 0) {
      headings.push(heading)
    } else {
      const currentParent = parentStack[parentStack.length - 1]
      currentParent.children.push(heading)
    }

    if (headingLevel >= parentStack.length) {
      parentStack.push(heading)
    }
  })
  return headings
}

export function parseGraphQLHeadings(
  gqlHeadings: {
    value: string
    depth: number
  }[],
): Heading[] {
  const headings: Heading[] = []
  let parentStack: Heading[] = []

  gqlHeadings.forEach(gqlHeading => {
    const headingLevel = gqlHeading.depth
    parentStack = parentStack.slice(0, headingLevel)

    const heading = {
      id: slug(gqlHeading.value),
      text: gqlHeading.value,
      children: [],
    }

    if (parentStack.length === 0) {
      headings.push(heading)
    } else {
      const currentParent = parentStack[parentStack.length - 1]
      currentParent.children.push(heading)
    }

    if (headingLevel >= parentStack.length) {
      parentStack.push(heading)
    }
  })
  return headings
}
